import { Soundtrack } from 'audio/Soundtrack';
import { ADD_AUDIO, removeSoundtrack } from 'state/actions';
import RootState from 'state/RootState';
import { Command, CommandFunction } from './Command';

export class RemoveSoundtrackCommand extends Command {
  soundtrack: Soundtrack | null;

  execute(firstTime?: boolean): CommandFunction {
    return async (dispatch: Function, getState: () => RootState) => {
      const { flyer } = getState();
      const { soundtrack } = flyer;
      if (soundtrack) {
        this.soundtrack = soundtrack;
        dispatch(removeSoundtrack());
      }
    };
  }

  undo(): CommandFunction {
    return async (dispatch: Function, getState: () => RootState) => {
      const { soundtrack } = this;
      if (soundtrack) {
        dispatch({
          type: ADD_AUDIO,
          soundtrack
        });
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/RemoveSoundtrackCommand.ts